import { assign } from 'xstate';
import { Context } from '../bookingMachine';

const assignBooking = assign<Context, any>({
    data: (ctx, evt) => evt.payload,
});

export default assignBooking;
